import React from "react";
import LazyLoad from "react-lazyload";
import SearchComp from "../../components/SearchComp";
import HomeHeydeskComp from "../../components/HomeHeydeskComp";
import WorkspaceComp from "../../components/WorkspaceComp";
import EnquiryComp from "../../components/EnquiryComp";
// import SignupPopup from "../../components/PopupComp/SignupPopup";
import { Helmet } from "react-helmet";
import "./style.scss";

export default class Home extends React.Component {
  render() {
    return (
      <div className="home">
        {/* <SignupPopup /> */}
        <Helmet>
          <meta
            name="description"
            content="dasdasdas dasda1432312312313131321"
          />
          <title>My Title</title>
          <link rel="canonical" href="http://mysite.com/example" />
        </Helmet>

        <SearchComp pathname={this.props.location.pathname} />

        <LazyLoad offset={50}>
          <HomeHeydeskComp />
        </LazyLoad>

        <LazyLoad offset={50}>
          <WorkspaceComp
            title="Workspaces and Meeting Rooms in"
            text="When you need to get united in the city, Heydesk's got the right space for you"
            location="Pondicherry, India"
            city_id={3124}
            country_id={101}
          />
        </LazyLoad>

        <LazyLoad offset={50}>
          <WorkspaceComp
            title="Workspaces and Meeting Rooms in"
            text="When you need to get united in the city, Heydesk's got the right space for you"
            location="New York, United States"
            city_id={48019}
            country_id={231}
          />
        </LazyLoad>

        <LazyLoad offset={50}>
          <EnquiryComp />
        </LazyLoad>

        <LazyLoad offset={50}>
          <WorkspaceComp
            title="Workspaces and Meeting Rooms in"
            text="When you need to get united in the city, Heydesk's got the right space for you"
            location="London, United Kingdom"
            city_id={41816}
            country_id={230}
          />
        </LazyLoad>

        <LazyLoad offset={50}>
          <WorkspaceComp
            title="Workspaces and Meeting Rooms in"
            text="When you need to get united in the city, Heydesk's got the right space for you"
            location="Aarhus, Denmark"
            city_id={14911}
            country_id={58}
          />
        </LazyLoad>
      </div>
    );
  }
}
